import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styles from "./pdui_dashboard_box.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

// Un equipo sin lecturas (recién agregado o nunca conectado) puede venir con
// nulos: mostrar 0.0 en vez de romper la página con `null.toFixed`.
const fmt = (value) => (Number.isFinite(value) ? value : 0).toFixed(1);

function Header({ name, pduiId }) {
  return (
    <Link to={`/detail/${pduiId}`} className={styles.headerContainer}>
      <div>{name}</div>
    </Link>
  );
}

function Footer() {
  return (
    <div className={`${styles.footerContainer}`}>
      <FontAwesomeIcon icon={faCaretDown} size={"2x"} color={"#CFCFCF"} />
    </div>
  );
}

export default function PduiDashboardBox({ key, data }) {
  const { t } = useTranslation();
  useEffect(() => {
    console.log("Data structure:", data);
  }, [data]);

  return (
    <div className={styles.container} key={key}>
      <Header name={data.pdui_name} pduiId={data.pdui_id} />

      <div className={"d-flex justify-content-center align-items-center"}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th />
              {data.has_nicknames && <th />}
              <th>{t('output.voltage').toUpperCase()}</th>
              <th>{t('output.current').toUpperCase()}</th>
              <th>{t('output.power').toUpperCase()}</th>
            </tr>
          </thead>
          <tbody>
            {(data.outputs || []).map((x) => {
              return (
                <tr key={x.id}>
                  <td>
                    <div className={styles.output}>
                      <div>{x.id}</div>
                      <div>OUT</div>
                    </div>
                  </td>

                  {data.has_nicknames && (
                    <td>
                      <div className={styles.nickname}>{x.nickname}</div>
                    </td>
                  )}

                  <td>
                    <div className={styles.value}>{fmt(x.voltage)}V</div>
                  </td>

                  <td>
                    <div className={styles.value}>{fmt(x.current)}A</div>
                  </td>

                  <td>
                    <div className={styles.value}>{fmt(x.power)}W</div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Footer />
    </div>
  );
}
